import { useQuery } from '@tanstack/react-query';
import { ApiError } from '../lib/api';
import { listCalendarEvents, type CalendarEventsFilters } from '../lib/calendarApi';

export function useCalendarEvents(filters: CalendarEventsFilters = {}, enabled = true) {
  return useQuery({
    queryKey: ['calendar-events', filters],
    queryFn: () => listCalendarEvents(filters),
    enabled,
    // A colleague's calendar one may not see is a 403 that will not change on
    // a retry; anything else keeps the client's default single retry.
    retry: (count, err) => !(err instanceof ApiError && err.status === 403) && count < 1,
  });
}
